import { useEffect, useState } from "react";
import JWPlayer from '@jwplayer/jwplayer-react';
import { formatDate } from '../helpers/formatDate';
import configData from '../config.json';

import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    FacebookMessengerShareButton,
    EmailShareButton
  } from "react-share";

const DetailsPage = ({ activeVideo,
    activeCategory,
    setActiveCategory,
    setActiveVideo,
    activeVideoMetadata,
    canShow 
}) => {

  const [rerender, setRerender] = useState(true);
  var currentUrl = window.location.href;

  useEffect(() => {
    setRerender(true);
  }, [activeVideo.id])

  useEffect(() => {
    if (rerender) {
      setRerender(false);
    }
  }, [rerender]);

  if((configData.BRAND).toUpperCase() === 'DELO'){
    var imgSrcBrand = configData.DELO.LOGO;
    var altImgBrand = configData.DELO.ALTIMG;
    var imgClassNameBrand = "d-logo-header d-delo-logo";
    }
    else {
        var imgSrcBrand = configData.SLOVENSKENOVICE.LOGO;
        var altImgBrand = configData.SLOVENSKENOVICE.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-novice-logo";
    }

  var categoryStyleClass = "container d-category-title-big " + activeCategory.styleClass;

  if(canShow){
    return (
        <>
                {!rerender && (
                    <div className="container d-video-container">
                        <div className="row">

                            <div className="col">
                                {activeVideo &&
                                
                                    <JWPlayer
                                        file={activeVideo.url}
                                        library='https://cdn.jwplayer.com/libraries/uSnweboJ.js'
                                        image={activeVideo.thumbnail}
                                    />
                                }
                                <div id="videoInfo" className="d-hide-element">
                                    <p>Playlist id: {activeCategory.id}</p>
                                    <p>Media id: {activeVideo.id}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="container d-video-info">
                    <div className="d-holder-maxw-1022">
                        <div className="row">
                            <div className="col-md-6 d-md-flex justify-content-md-center flex-md-column" data-aos="fade-right" data-aos-delay="400">
                                <h2 className="d-fsc-video-title mt-2">{activeVideo.title}</h2>
                                <label className="d-fsc-video-date">{formatDate(activeVideo.creationDate)}</label>
                                <div className="d-social-links mt-3">

                                    {/* Email */}
                                    <EmailShareButton
                                        url={window.location.href}
                                        // quote={'Text...'}
                                        // hashtag={'#exampletag...'}
                                        >
                                        <i className="fa-regular fa-envelope"></i>
                                    </EmailShareButton>

                                    {/* Facebook */}
                                    <FacebookShareButton
                                        url={currentUrl}
                                        // quote={'Text...'}
                                        // hashtag={'#exampletag...'}
                                        >
                                            <i className="fa-brands fa-facebook-f"></i>
                                    </FacebookShareButton>

                                    {/* Facebook messanger */}
                                    {/* <FacebookMessengerShareButton
                                        url={currentUrl}
                                        // quote={'Text...'}
                                        // hashtag={'#exampletag...'}
                                        >
                                            <i className="fa-brands fa-facebook-messenger"></i>
                                    </FacebookMessengerShareButton> */}

                                    {/* Twitter */}
                                    <TwitterShareButton
                                        url={currentUrl}
                                        // quote={'Text...'}
                                        // hashtag={'#exampletag...'}
                                        >
                                            <svg className="d-svg-icon"><use xlinkHref="#x-logo-bold" /></svg>
                                    </TwitterShareButton>

                                    {/* Linkedin */}
                                    <LinkedinShareButton
                                        url={currentUrl}
                                        // quote={'Text...'}
                                        // hashtag={'#exampletag...'}
                                        >
                                        <i className="fa-brands fa-linkedin"></i>
                                    </LinkedinShareButton>
                                </div>

                            </div>
                            {!rerender && (
                            <div className="col-md-6 d-flex align-items-center" data-aos="fade-left" data-aos-delay="400">
                                <div className="my-4">
                                <div className="d-fsc-video-description mb-4">
                                    {/* Description */}
                                    {activeVideo.description && activeVideo.description !== "" && (
                                        <span className="video-desc">{activeVideo.description}
                                        </span> 
                                    )}
                                    {/* Author */}
                                    {activeVideoMetadata && JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).author !== "" && (
                                        <span className="video-author"><i className="fa-regular fa-pencil icon"></i> {JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).author}
                                        </span>
                                    )}
                                </div>
                                {/* Tags */}
                                {activeVideoMetadata &&
                                 JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).tags.length > 0  && 
                                (
                                    <div className="video-tags">
                                        <span className="video-tags-title">Tagi:</span>
                                        {JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).tags.map((tag) => (
                                            <span className="video-tag">{tag}</span>
                                        ))}
                                    </div>
                                )}
                                {/* Permalink */}
                                {activeVideoMetadata &&
                                 JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).permalink !== ""  && 
                                (
                                    <a href={JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).permalink} target={"_blank"} className="video-article-link"><i className="fa-regular fa-arrow-right icon"></i> Kliknite za izvirni članek</a>
                                )}
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={categoryStyleClass}>
                    <div className="row mb-3">
                        <div className="col" data-aos="fade-right" data-aos-delay="400">
                            <h2 className="d-category-title"><span className="d-holder-maxw-1022"><span className="d-title">{activeCategory.name}</span></span></h2>
                        </div>
                    </div>
                </div>
        </>
    );
                                }
                                else {
                                    return (
                                        <div id="preloader" className="preloader d-bg-transparent-85">
                                            <img src={imgSrcBrand} className={imgClassNameBrand} alt={altImgBrand}/>
                                        </div>
                                    );
                                }
};

export default DetailsPage;